<template>
  <div class="main-body">
    <div class="header">用药记录</div>
    <div class="out">

      <div class="search2">

        <div style="float:right;">

          <el-select v-model="institutionCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" v-loading="loading"
                :height="th" border >

        <el-table-column type="expand" v-if="tableData.length">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="药品组：" v-if="props.row.listMedicationSchedulingMorningItemDTO != null ">

<!--                <el-tag v-for="(value,i) in props.row.listMedicationSchedulingMorningItem" :key="i"-->
<!--                        style="margin-right: 5px">{{value.medicationGroupName}}</el-tag>-->



                <el-popover v-for="(value,i) in props.row.listMedicationSchedulingMorningItemDTO" :key="i"
                            placement="right"
                            width="160"
                            title="药品" style="margin-right: 5px;"
                            trigger="hover">

                  <div v-for="(value2,i2) in value.listMedicationItem" :key="i2">
                    <span>{{value2.name}}</span>
                  </div>

                  <el-tag type="success" slot="reference">{{value.medicationGroupName}}</el-tag>

                </el-popover>


              </el-form-item>
              <el-form-item label="药品组：" v-if="props.row.listMedicationSchedulingNoonItemDTO != null ">
<!--                <el-tag v-for="(value,i) in props.row.listMedicationSchedulingNoonItem" :key="i"-->
<!--                        style="margin-right: 5px">{{value.medicationGroupName}}</el-tag>-->

                <el-popover v-for="(value,i) in props.row.listMedicationSchedulingNoonItemDTO" :key="i"
                            placement="right"
                            width="160"
                            title="药品" style="margin-right: 5px;"
                            trigger="hover">

                  <div v-for="(value2,i2) in value.listMedicationItem" :key="i2">
                    <span>{{value2.name}}</span>
                  </div>

                  <el-tag type="success" slot="reference">{{value.medicationGroupName}}</el-tag>

                </el-popover>

              </el-form-item>
              <el-form-item label="药品组：" v-if="props.row.listMedicationSchedulingNightItemDTO != null ">
<!--                <el-tag v-for="(value,i) in props.row.listMedicationSchedulingNightItem" :key="i"-->
<!--                        style="margin-right: 5px">{{value.medicationGroupName}}</el-tag>-->

                <el-popover v-for="(value,i) in props.row.listMedicationSchedulingNightItemDTO" :key="i"
                            placement="right"
                            width="160"
                            title="药品" style="margin-right: 5px;"
                            trigger="hover">

                  <div v-for="(value2,i2) in value.listMedicationItem" :key="i2">
                    <span>{{value2.name}}</span>
                  </div>

                  <el-tag type="success" slot="reference">{{value.medicationGroupName}}</el-tag>

                </el-popover>


              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>
        <el-table-column prop="recordType" label="用药人">
          <template slot-scope="scope">
            <span v-if="scope.row.recordType == 'mediciner'">[医生]{{scope.row.medicinerName}}</span>
            <span v-if="scope.row.recordType == 'nurse'">[护士]{{scope.row.nurseName}}</span>
            <span v-if="scope.row.recordType == 'nurseAide'">[护工]{{scope.row.nurseAideName}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="timeType" label="类型"></el-table-column>

        <el-table-column prop="createTime" :formatter="formatTime" label="用药时间"></el-table-column>


      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>


  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Page",
  data(){
    return{
      loading:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      arr_ins:[],
      institutionCode: '',

    }
  },
  components:{

  },
  created(){
    this.getIns();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{


    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },


    getList(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"MedicationRecord/GovPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          institutionCode:this.institutionCode,
        }
      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    formatTime:function (row, column, cellValue) {
      return timefilters(cellValue);
    },

  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-table__body tr.current-row>td {
  background-color: #409EFF;
  color:#fff;
}

</style>
